import statuses from '../../statuses';
import mutations from './mutations';
import actions from './actions';

const defaultState = () => {
  return {
    jiraProjects: {
      data: [],
      status: statuses.EMPTY,
    },
    jiraProjectsUpdate: {
      data: [],
      status: statuses.EMPTY,
    },
    jiraProjectsPushUpdate: {
      data: [],
      status: statuses.EMPTY,
    },
    jiraIssues: {
      data: [],
      status: statuses.EMPTY,
    },
    jiraIssuesSearch: {
      data: [],
      status: statuses.EMPTY,
    },
    // jiraProjectIssues: {
    //   data: [],
    //   status: statuses.EMPTY,
    // },
    jiraIssueData: {
      data: [],
      status: statuses.EMPTY,
    },
    jiraProjectsResetEntities: {
      data: [],
      status: statuses.EMPTY,
    }
  };
};

const Jira = {
  namespaced: true,
  state: defaultState,
  getters: {
    jiraProjects: (state) => state.jiraProjects,
    jiraProjectsUpdate: (state) => state.jiraProjectsUpdate,
    jiraProjectsPushUpdate: (state) => state.jiraProjectsPushUpdate,
    jiraIssues: (state) => state.jiraIssues,
    jiraIssuesSearch: (state) => state.jiraIssuesSearch,
    // jiraProjectIssues: (state) => state.jiraProjectIssues,
    jiraIssueData: (state) => state.jiraIssueData,
    jiraProjectsResetEntities: (state) => state.jiraProjectsResetEntities
  },
  mutations,
  actions,
};

export { Jira, defaultState };
